// import { gsap } from 'gsap';

let latestWorksEllipseTL, latestWorksImgTL, latestWorksImgSecondTL;

window.latestWorksGradientGSAPAnimation = function () {
  const imgContainer = document.querySelector(
    '.latest-works-bg__bg-decor-ellipses'
  );
  const main = document.querySelector('.main');

  if (!imgContainer || !main) return;

  if (window.innerWidth > 1024) {
    imgContainer.getBoundingClientRect();

    requestAnimationFrame(() => {
      const img = imgContainer.querySelector(
        '.latest-works-bg__bg-decor-ellipse-img-wr:nth-child(1) .latest-works-bg__bg-decor-ellipse-img'
      );
      const imgSecond = imgContainer.querySelector(
        '.latest-works-bg__bg-decor-ellipse-img-wr:nth-child(2) .latest-works-bg__bg-decor-ellipse-img'
      );

      gsap.set(imgContainer, {
        xPercent: 0,
        yPercent: -50,
        x: 0,
        y: 0,
        transformOrigin: 'right bottom',
      });

      latestWorksEllipseTL = gsap.to(imgContainer, {
        rotation: 360,
        ease: 'none',
        repeat: -1,
        duration: 30,
      });

      latestWorksImgTL = gsap.to(img, {
        rotation: -360,
        ease: 'none',
        repeat: -1,
        duration: 30,
      });

      latestWorksImgSecondTL = gsap.to(imgSecond, {
        rotation: 360,
        ease: 'none',
        repeat: -1,
        duration: 40,
      });
    });
  }
};

window.pauseLatestWorksGradientAnimation =
  function pauseLatestWorksGradientAnimation() {
    if (window.innerWidth > 1024) {
      latestWorksEllipseTL?.pause();
      latestWorksImgTL?.pause();
      latestWorksImgSecondTL?.pause();

      /*console.log(
        latestWorksEllipseTL?.paused(),
        latestWorksImgTL?.paused(),
        latestWorksImgSecondTL?.paused()
      );*/
    }
  };

window.resumeLatestWorksGradientAnimation =
  function resumeLatestWorksGradientAnimation() {
    if (window.innerWidth > 1024) {
      latestWorksEllipseTL?.play();
      latestWorksImgTL?.play();
      latestWorksImgSecondTL?.play();

      /*console.log(
        latestWorksEllipseTL?.paused(),
        latestWorksImgTL?.paused(),
        latestWorksImgSecondTL?.paused()
      );*/
    }
  };

latestWorksGradientGSAPAnimation();

if (!document.querySelector('.bold-loader-new')) {
  pauseLatestWorksGradientAnimation();
}
